import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// The `--text-*` steps added to `@theme` generate `text-<name>` font-size
// utilities that tailwind-merge cannot recognise, so it classifies them as
// text *colors* and drops the real color class it thinks they replace
// (`cn('text-primary-foreground', 'text-data')` collapsed to `text-data`).
// Registering them in the font-size group restores the correct conflict
// resolution; extend this list whenever a `--text-*` token is added.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['micro', 'eyebrow', 'data', 'display-sm'] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function appPath(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const base = import.meta.env.BASE_URL.replace(/\/+$/, '');
  return base ? `${base}${normalizedPath}` : normalizedPath;
}

export function assetPath(path: string): string {
  return appPath(path);
}
